import { ChakraProvider, extendTheme } from '@chakra-ui/react';

import { AuthProvider } from './lib/contexts/AuthContext';
import AppRoutes from './routes';


import { theme } from "./lib/theme"; // Import your custom theme

function App() {
  return (
    <AuthProvider>
      <ChakraProvider theme={theme}>
        <AppRoutes />
      </ChakraProvider>
    </AuthProvider>
  );
}

export default App;
